<template>
  <div class="banner-dialog-wrapper">
    <div :class="['banner-dialog', {'with-text': withTextContent}, {'not-xs': $vuetify.breakpoint.smAndUp}, {'flex-column': $vuetify.breakpoint.xsOnly}]">
      <div class="banner-dialog-img-wrapper">
        <v-img :src="'/api/static/' + banner.banner"
               class="banner-dialog-img-blur"
               v-if="withTextContent"></v-img>

        <v-img :src="'/api/static/' + banner.banner" contain
               @click="onImageClick"></v-img>
      </div>
      <div class="banner-dialog-content-wrapper"
           v-if="withTextContent">
        <div class="banner-dialog-content"
             v-html="banner.content"></div>
      </div>
      <div class="banner-dialog-close-btn"
           @click="$emit('submit')">
        <v-icon color="primary"
                x-large>mdi-close-circle
        </v-icon>
      </div>
    </div>
  </div>
</template>

<script>
import {computed, onMounted} from "@vue/composition-api";

export default {
  name: 'BannerDialog',
  props: {
    banner: Object,
  },
  setup(props, {root, emit}) {
    const withTextContent = computed(() => {
      return !!props.banner.content;
    });

    const onImageClick = function () {
      if (props.banner.link) {
        window.open(props.banner.link, '_blank');
      }
    }

    onMounted(() => {
      console.log(props.banner);
    })

    return {
      withTextContent,
      onImageClick,
    }
  },
}
</script>

<style lang="less">
.banner-dialog-wrapper {
  height: 100vh;
  width: 100vw;
  display: flex;
  background-color: rgba(33, 33, 33, 0.46);

  .banner-dialog {
    width: 90%;
    height: 90%;
    max-width: 640px;
    max-height: 768px;
    margin: auto;

    display: flex;
    position: relative;

    &.not-xs {
      max-height: 480px;
    }

    .banner-dialog-img-wrapper {
      flex: 1 1 0;
      overflow: hidden;
      display: flex;
      align-content: center;
      justify-content: center;
      position: relative;

      .banner-dialog-img-blur {
        position: absolute;
        width: 100%;
        height: 100%;
        opacity: 0.5;
        filter: blur(1rem);
      }
    }

    &.with-text {
      background: #fff;
      border-radius: 4px;
    }

    &.flex-column {
      .banner-dialog-img-wrapper {
        flex: 0 0 auto !important;
      }
    }


    .banner-dialog-content-wrapper {
      flex: 1 1 0;
      overflow: auto;
      padding: 64px 32px 32px;

      .banner-dialog-content {
        text-align: initial;
      }
    }

    &.flex-column {
      .banner-dialog-content-wrapper {
        padding: 32px !important;
      }
    }
  }

  .banner-dialog-close-btn {
    position: absolute;
    right: 8px;
    top: 8px;
    cursor: pointer;
  }
}
</style>
